import React from 'react';
import { GetStaticProps } from 'next';
import { MemberManager } from 'modules/App/server';
import HeaderLayout from 'modules/common/layouts/HeaderLayout';
import Hero from 'lib/components/ui/hero';
import { useAuthModal } from 'modules/auth';
import dbConnect from 'utils/db';
import { Section } from '@/lib/components/layout/section';
import RecruitersList from 'modules/App/components/RecruitersList';
import RecruitersCities from 'modules/App/components/RecruitersCities';
import { parseAsString, useQueryState } from 'nuqs';
import { track } from '@/lib/analytics/client';
import { whatsappDorothee } from 'modules/App/config';

export interface RecruitersProps {
  recruiters: any[];
  cities: string[];
}

function Recruiters({ recruiters, cities }: RecruitersProps) {
  const { toggleModal } = useAuthModal();
  const [displayMode] = useQueryState('displayMode', parseAsString.withDefault('map'));
  return (
    <HeaderLayout
      title={`${recruiters.length} recruteurs prêts à collaborer`}
      description="Liste des recruteurs et de leur spécialités, secteurs, métiers, etc..."
    >
      <Hero
        title={
          <>
            {displayMode === 'table' ? (
              <>
                Liste des <span className="text-primary">{recruiters.length}</span> recruteurs
                <br />
                prêts à collaborer
              </>
            ) : (
              <>
                Carte des <span className="text-primary">{recruiters.length}</span> recruteurs
                <br />
                prêts à collaborer
              </>
            )}
          </>
        }
        description={
          <>
            Tu cherches à collaborer avec des recruteurs de confiance ?<br />
            <strong className="link link-primary" onClick={() => toggleModal()}>
              Inscris-toi
            </strong>{' '}
            maintenant.
            <div className="italic text-sm mt-5">
              <strong>Vous êtes une entreprise et cherchez un recruteur&nbsp;?</strong>.{' '}
              <a
                href={`${whatsappDorothee}?text=${encodeURIComponent(
                  `Bonjour Dorothée, je cherche un recruteur et j'ai vu sur Headlinker que vous pouviez me mettre en relation`
                )}`}
                onClick={() => track('recruiters.company.contact')}
                target="_blank"
                rel="noopener noreferrer"
                className="link link-secondary"
              >
                Nous vous mettons en relation.
              </a>
            </div>
          </>
        }
      />
      <RecruitersList recruiters={recruiters} />
      <Section className="bg-gray-50">
        <RecruitersCities cities={cities} />
      </Section>
    </HeaderLayout>
  );
}

export const getStaticProps: GetStaticProps<RecruitersProps> = async () => {
  await dbConnect();

  const { items: recruiters, cities } = await MemberManager.listNotConnected();

  return {
    props: {
      recruiters: JSON.parse(JSON.stringify(recruiters)),
      cities: JSON.parse(JSON.stringify(cities.map((city) => city.slug))),
    },
  };
};

export default Recruiters;
